import { Injectable } from "@angular/core";
import { Content } from "../models/content.model";
import { GraphQLService } from "./graphql.service";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class ContentService extends GraphQLService<Content> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  pages(iso: string, area: number) {
    // areas: 1: Main nav, 2: Footer nav, 3: right nav
    return this.findAll(`{ webpages(iso: "${ iso }", area: ${ area }) { id slug title } }`)
  }

  page(id: number, iso: string) {
    return this.find(`{ webpage(id: ${ id }, iso: "${ iso }") { id slug title body } }`)
  }

}
